import { PagePaths } from '~/app/routes'
import { StatusCode } from '~/store/slices/filterSlice'
import { RecurringAssignmentType } from '~/storm'

export type SurgeonSchedulerPaths = PagePaths['SURGEON_SCHEDULER']

export const PoliclinicStatuses: StatusCode[] = ['POLICLINIC', 'LARYNX', 'REGON', 'KNEE_TEAM', 'SLEEP']

export const allRecurringAssignmentStatusDays = (recurringAssignment: RecurringAssignmentType) => [
    recurringAssignment.monday_status,
    recurringAssignment.tuesday_status,
    recurringAssignment.wednesday_status,
    recurringAssignment.thursday_status,
    recurringAssignment.friday_status,
    recurringAssignment.saturday_status,
    recurringAssignment.sunday_status,
]

export const allRecurringAssignmentRoomDays = (recurringAssignment: RecurringAssignmentType) => [
    recurringAssignment.monday_room,
    recurringAssignment.tuesday_room,
    recurringAssignment.wednesday_room,
    recurringAssignment.thursday_room,
    recurringAssignment.friday_room,
    recurringAssignment.saturday_room,
    recurringAssignment.sunday_room,
]
